import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Main />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
